var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIndicatorsLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 12,
    fill: "#064AD3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1 9.58L11.1 7.85V7.375C11.1 7.17 10.93 7 10.725 7C10.52 7 10.35 7.17 10.35 7.375V16.625C10.35 16.83 10.52 17 10.725 17C10.93 17 11.1 16.83 11.1 16.625V14.645L15.21 12.615C15.21 12.615 15.21 12.615 15.215 12.615C16.045 12.185 16.49 11.63 16.465 11.045C16.44 10.46 15.955 9.94 15.1 9.58Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicatorsLogo);
export default __webpack_public_path__ + "static/media/IndicatorsLogo.5a7e5186ca0fd73f44d2052a039e2843.svg";
export { ForwardRef as ReactComponent };